module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/02_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 1.")]), _vm._v("A Woman in Green and a Man in Gray.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter02"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 2.")]), _vm._v("The Czar of Poisonville.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/05_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 3.")]), _vm._v("Dinah Brand.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 4.")]), _vm._v("Hurricane Street.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 5.")]), _vm._v("Old Elihu Talks Sense.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 6.")]), _vm._v("Whisper‘s Joint.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 7.")]), _vm._v("That‘s Why Sewed You Up.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 8.")]), _vm._v("A Tip on Kid Cooper.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocc"
  }, [_vm._v("Chapter 9.")]), _vm._v("A Black Knife.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 10.")]), _vm._v("Crime Wanted—Male or Female.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 11.")]), _vm._v("The Swell Spoon.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 12.")]), _vm._v("A New Deal.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 13.")]), _vm._v("-$200.10-")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 14.")]), _vm._v("Max.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 15.")]), _vm._v("Cedar Hill Inn.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 16.")]), _vm._v("Exit Jerry.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 17.")]), _vm._v("Reno.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 18.")]), _vm._v("Painter Street.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 19.")]), _vm._v("The Peace Conference.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 20.")]), _vm._v("Laudanum.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 21.")]), _vm._v("The Seventeenth Murder.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 22.")]), _vm._v("The Ice Pick.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 23.")]), _vm._v("Mr. Charles Proctor Dawn.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 24.")]), _vm._v("Wanted.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 25.")]), _vm._v("Whiskeytown.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 26.")]), _vm._v("Blackmail.")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocy"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("Chapter 27.")]), _vm._v("Warehouses.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 72
// module chunks = 0